import { styled } from "@mui/material/styles";


const StyledWrapper = styled('div')<{ menu: boolean }>`
  min-height: calc(100vh - 104px);

  .profile-page {
    &__container {
      display: flex;
      gap: 30px;
      padding-top: 30px;
      padding-bottom: 50px;
    }

    &__sidebar {
      width: 250px;
      flex-shrink: 0  ;
    }

    &__content {
      flex-grow: 1;
    }

    &__back-menu-btn {
      margin-bottom: 1rem;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
      }
    }
  }
  
  @media (max-width: 991.98px) {

    .profile-page {
      &__container {
        gap: 0;
        padding-top: 30px;
        padding-bottom: 50px;

        overflow: hidden;
      }

      &__sidebar {
        visibility: ${ props => props.menu ? 'visible' : 'hidden' };
        width: ${ props => props.menu ? '100%' : '0' };
        height: ${ props => props.menu ? 'auto' : '0' };
        /* transition: width 0.3s ease; */
        overflow: hidden;
      }

      &__content {
        visibility: ${ props => props.menu ? 'hidden' : 'visible' };
        width: ${ props => props.menu ? '0' : '100%' };
        height: ${ props => props.menu ? '0' : 'auto' };
        /* transition: width 0.3s ease; */
        overflow: hidden;
        flex-grow: 0;
      }

    }
  }

  @media (max-width: 767.98px) {
    min-height: calc(100vh - 74px);

    .profile-page {
      &__container {
        gap: 0;
        padding-top: 20px;
        padding-bottom: 30px;
      }
    }
  }
`;

export {
  StyledWrapper,
};

